import { gql } from '@apollo/client';

const LANGUAGES = gql`
    query Language {
        languages {
            code
            id
            name
            nativeName
        }
    }
`;

export default LANGUAGES;
